import React, { Component } from "react";
import "./Review.scss";
import moment from "moment";
import StarRating from "./StarRating";

class CreatedAtDate extends Component {
  render() {
    return <span ref="span" className="time"></span>;
  }

  componentDidMount() {
    const text = moment(this.props.time).format("MMM D, YYYY");
    this.refs.span.innerHTML = text;
  }
}

const capitalize = (string) => {
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const nameSpan = (name) => {
  if (name) {
    return <span className="name">{name}</span>;
  }
};

export default ({ comment, rating, name, created_at, title, business_name, city, state, showLocation }) => {
  return (
    <div className="review row">
      <div className="blue-block"></div>
      <div className="meta col-sm-3 mol-xs-12">
        <div>{nameSpan(name)}</div>
        <div>{business_name}</div>
        {showLocation && city && state && (
          <div>
            {capitalize(city)}, {state.toUpperCase()}
          </div>
        )}
        <CreatedAtDate time={created_at} />
      </div>
      <div className="content col-sm-9 col-xs-12">
        <h3>{title}</h3>
        <StarRating rating={rating} />
        <div className="comment">{comment}</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/shared/Review.js